import { render, staticRenderFns } from "./JuniorStockdogStandardScores.vue?vue&type=template&id=60b45918"
import script from "./JuniorStockdogStandardScores.vue?vue&type=script&lang=ts"
export * from "./JuniorStockdogStandardScores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports